<ish-checkout-progress-bar [step]="checkoutStep$ | async" />

<router-outlet />
